<template>
<div>
  <!-- <el-collapse v-model="store.settings.showSpeciesPane" style="margin-top: 10px;" id='browse-collapse'>
    <el-collapse-item name="1">
      <template slot="title">
        <div style="text-align:center">
        <h3 style="padding-left: 20px;">Species Table Pane</h3>
        </div>
      </template> -->
      <el-row style="margin-top: 10px;">
        <el-col :span="24">
          <el-form :inline="true" size="medium">
            <div style="margin-bottom: 10px; font-size: 1.1em;">Showing {{ store.settings.speciesTableCurrentStart + 1 }} to {{ store.settings.speciesTableCurrentStop > paginationTotal ? paginationTotal : store.settings.speciesTableCurrentStop }} species of {{ paginationTotal }}, {{ selectedIDs.length }} species selected</div>
            <el-form-item>
              <el-input placeholder="Search species by name..." v-model="store.settings.speciesTableSearchString" @change="handleSearch"></el-input>
            </el-form-item>
            <el-form-item>
              <el-tooltip content="Click or Press Enter to search" placement="top">
                <el-button type="primary" icon="el-icon-search" @click="handleSearch"></el-button>
              </el-tooltip>
            </el-form-item>
            <el-form-item>
              <el-pagination background :page-size.sync="store.settings.speciesTablePageSize" @size-change="handleSizeChange" :current-page.sync="store.settings.speciesTableCurrentPage" @current-change="handlePageChange" :page-sizes="store.settings.speciesTablePageSizeOptions" :total="paginationTotal" layout="jumper, prev, pager, next, sizes" :pager-count="5">
            <span>Slot Test</span>
              </el-pagination>
            </el-form-item>
            <el-form-item label="Sort Species By">
              <el-select v-model="store.settings.speciesTableSortBy" @change="handleSortChange">
                <el-option label="Selection" value="selected"></el-option>
                <el-option v-for="option in store.species.table.columns.filter(c => c.sortable)" :key=option.name :label="option.label" :value="option.name"></el-option>
              </el-select>
              <el-checkbox label="Ascending" :disabled="store.settings.speciesTableSortBy === 'selected'" style="margin-left: 10px;" true-label="asc" false-label="desc" v-model="store.settings.speciesTableSortDirection" @change="handleSortChange"></el-checkbox>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <!-- <el-row style="margin-bottom: 10px;">
        <el-col :span="24">
                <el-form inline style="text-align: left" label-position="top">
                  <el-form-item v-for="filter in selectionFilters" :key="filter.name" :label="filter.name">
                    <el-select v-model="filter.values" multiple collapse-tags >
                      <el-option v-for="option in getFilterOptions(filter.name)" :key="option" :label="option" :value="option"></el-option>
                    </el-select>
                  </el-form-item>              
                  <el-form-item v-for="filter in rangeFilters" :key="filter.name" :label="filter.name">
                    <el-slider v-model="filter.values" :min="filter.min" :max="filter.max" show-input range></el-slider>
                  </el-form-item>
                </el-form>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="24">
          <el-table :data="store.species.displayed" :height="500" size="mini" border :header-cell-style="headerStyle" ref="speciesTable" :row-class-name="tableRowClassName">
            <el-table-column v-for="col in activeColumns" :key="col.name" :prop="col.name" :label="col.label" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column label="Actions" fixed="right" width="120">
              <template slot-scope="action">
              <el-button type="success" icon="el-icon-check" size="mini" circle plain @click="handleSpeciesSelection(action.row)"></el-button>
              <el-button type="danger" icon="el-icon-close" size="mini" circle plain @click="handleSpeciesRemoval(action.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
</div>
    <!-- </el-collapse-item>
  </el-collapse> -->
</template>

<script>
import { store } from '../scripts/store.js'
import { events } from '../scripts/events.js'

const _ = require('lodash')

export default {
  data () {
    return {
      store: store,
      headerStyle: {
        "background-color": "#EEF1F6",
        "color": "#324157",
        "font-weight": "bold",
        "font-size": "1.1em",
        "border": "1px solid #dcdcdc"
      },
      showFilterDialog: false
    }
  },
  computed: {
    paginationTotal () {
      return _.filter(store.species.list, 'show').length
    },
    activeColumns () {
      return _.filter(store.species.table.columns, 'show')
    },
    kingdomFilterOptions () {
      return this.getFilterOptions('Kingdom')
    },
    groupFilterOptions () {
      return this.getFilterOptions('Group')
    },
    subgroupFilterOptions () {
      return this.getFilterOptions('SubGroup')
    },
    sourceFilterOptions () {
      return this.getFilterOptions('Source')
    },
    assemblyFilterOptions () {
      return this.getFilterOptions('AssemblyLevel')
    },
    selectedIDs () {
      return _.map(_.filter(store.species.list, 'selected'), 'MSDBID')
    },
    selectionFilters () {
      return _.filter(store.filters, ['type', 'selection'])
    },
    rangeFilters () {
      return _.filter(store.filters, ['type', 'range'])
    }
  },
  methods: {
    getFilterOptions (name) {
      const filters = []
      for (let key of _.uniq(_.map(store.species.list, name))){
        filters.push(key)
      }
      return filters.sort()
    },
    tableRowClassName ({row}) {
      if (this.selectedIDs.includes(row.MSDBID)) {
        return 'selected-row'
      }
    },
    handleSpeciesSelection (row) {
      if (this.selectedIDs.includes(row.MSDBID)) {
        events.$message({
          message: 'Genome already in selected list',
          type: 'warning'
        })
      } else {
        store.addSpecies(row, 'Select Button Click')
      }
    },
    handleSpeciesRemoval (row) {
      store.removeSpecies(row, 'Deselect Button Click')
    },    
    handleSizeChange () {
      store.getDisplayedSpecies('Page Size Change')
    },
    handlePageChange () {
      store.getDisplayedSpecies('Current Page Change')
    },
    handleSortChange (value) {
      if (store.settings.debug) {
        console.log(`Sort order changed to ${value}`)
      }
      store.sortSpeciesList('Species Table Sort Select')
    },
    handleSearch () {
      store.searchSpecies('Search Box')
    }
  }
}
</script>

<style>
span.el-table__column-filter-trigger > i {
  color: #324157 !important;
  font-size: 1.2em;
}

.el-table .selected-row {
  background-color: #f0f9eb;
}
</style>


